import { useState } from "react";
import { Table, Tooltip, Card } from "antd";
import { styled } from "@mui/system";

const StyledTableWrapper = styled(Table)`
  .ant-table {
    background: transparent;
    font-family: "DM Sans", sans-serif;
    color: #121212;
  }

  .ant-table-thead > tr > th {
    background: #f0f0f0 !important;
    font-family: "DM Sans", sans-serif;
    font-weight: 500;
    font-size: 12px;
    color: #121212;

    white-space: normal !important;
    overflow: visible !important;
  }

  .ant-table-column-title {
    white-space: normal !important;
    line-height: 1.3 !important;
    display: inline-block;
    flex: 0 1 auto !important;
  }

  .ant-table-thead > tr > th.ant-table-cell-fix-left,
  .ant-table-thead > tr > th.ant-table-cell-fix-right {
    z-index: 20 !important;
    background: #f0f0f0 !important;
  }

  .ant-table-column-sorters {
    justify-content: flex-start;
    gap: 4px;
  }

  .ant-table-tbody > tr > td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 12px 16px;

    font-family: "DM Sans", sans-serif;
    font-size: 14px;
    color: #121212;
  }

  .row-red .ant-table-cell {
    background-color: #ffccc7 !important;
  }
  .row-orange .ant-table-cell {
    background-color: #ffe7ba !important;
  }

  .ant-table-tbody > tr:hover > td {
    background-color: #fafafa;
  }

  .ant-table-pagination.ant-pagination {
    margin: 1rem !important;
  }
`;

export const TooltipCell = ({ text, width = "150px" }) => (
  <Tooltip
    title={
      <div style={{ maxHeight: "200px", overflowY: "auto", whiteSpace: "normal" }}>{text}</div>
    }>
    <div
      style={{
        maxWidth: width,
        minWidth: width,
        overflow: "hidden",
        textOverflow: "ellipsis",
        cursor: "default",
      }}>
      {text}
    </div>
  </Tooltip>
);

const SharedTable = ({
  columns,
  dataSource,
  loading,
  pagination,
  tableName,
  rowClassName,
  onRowClick,
  scroll,
  ...rest
}) => {
  const [internalPageSize, setInternalPageSize] = useState(() => {
    if (tableName) {
      const saved = localStorage.getItem(`${tableName}_pageSize`);
      return saved ? Number(saved) : 20;
    }
    return 20;
  });
  const defaultPagination = {
    position: ["bottomRight"],
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
    pageSize: internalPageSize,
    onChange: (page, newSize) => {
      setInternalPageSize(newSize);
      if (tableName) {
        localStorage.setItem(`${tableName}_pageSize`, newSize);
      }
      if (pagination && pagination.onChange) {
        pagination.onChange(page, newSize);
      }
    },
  };

  const mergedPagination =
    pagination === false
      ? false
      : { ...defaultPagination, ...pagination, pageSize: internalPageSize };

  const defaultScroll = { x: "max-content" };

  return (
    <Card
      style={{
        width: "100%",
        overflow: "hidden",
        margin: "10px 0",
      }}
      styles={{ body: { padding: "0px" } }}>
      <StyledTableWrapper
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        rowKey={(record) => record.id || record.key || record.uid}
        bordered={false}
        pagination={mergedPagination}
        scroll={{ ...defaultScroll, ...scroll }}
        rowClassName={rowClassName}
        onRow={(record) => ({
          onClick: () => onRowClick && onRowClick(record),
        })}
        {...rest}
      />
    </Card>
  );
};

export default SharedTable;
